module.exports = (function() {
    return {
        getValue(key) {
            let bitdashConfig = window.localStorage && window.localStorage.getItem('bitdash_config');
            let value = 0;
            try {
                bitdashConfig = JSON.parse(bitdashConfig);
                value = bitdashConfig[key];
            } catch(err) {
                // dummy defaults
                bitdashConfig = JSON.parse('{"audioLang":"en","volume":100, "muted": false}');
            }
            return value || bitdashConfig[key];
        }
    };
}());



// WEBPACK FOOTER //
// ./src/util/defaults.js